import { tourStep } from './tourRegistry';

export const bandaComunidadSteps = [
  tourStep(
    'comunidad-header',
    'Comunidad',
    'Directorio para encontrar cofradías y otras entidades. El perfil público de la banda es lo que ellas ven de vosotros.',
  ),
  tourStep(
    'comunidad-buscar',
    'Buscar',
    'Escribe nombre, lugar o una palabra de la descripción. Los resultados se actualizan al momento.',
  ),
  tourStep(
    'comunidad-filtros',
    'Filtros y orden',
    'Acota por tipo, distancia o fechas, y ordena por cercanía, nombre o confianza.',
  ),
];
